// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FileAddFilledSvg from "@fishx/icons-svg/es/asn/FileAddFilled";
import FishxIcon from '../components/FishxIcon';

var FileAddFilled = function FileAddFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FileAddFilledSvg
  }));
};

FileAddFilled.displayName = 'FileAddFilled';
export default React.forwardRef(FileAddFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FileAddFilled.js
// module id = 2686
// module chunks = 0